import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import TablePagination from "@mui/material/TablePagination";
import { TableSortLabel } from "@mui/material";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../common/CommonLoader";
import UserService from "../../../globel-constants/UserService";
import { GetVlpReports } from "../../services/ReportSettingsService";
import {
  getComparator,
  stableSort,
} from "../../../common-utilities/sortingUtils";

const AdminReports = () => {
  // Define the authentication details
  //const reportServer = "elabsql1";
  const reportServer = "ENVLAB-File01";
  //  const reportServer = "10.0.0.4";
  const reportAccount = "SSRSUser";
  const reportPassword = "P@ssword1!";
  const rowsPerPageOptions = [10, 25, 50, 100, 200, 300];

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredReports, setFilteredReports] = useState([]);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("asc");
  const [adminReportsData, setAdminReportsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [appActiveRoute, setAppActiveRoute] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let user = UserService.getUserInfoFromLocalStorage();
    let isMounted = true;

    const fetchReports = async (route) => {
      try {
        setLoading(true);
        const response = await GetVlpReports(route);
        if (isMounted) {
          const results = response?.results || [];
          setAdminReportsData(results);
          setFilteredReports(results);
        }
      } catch (error) {
        if (isMounted) {
          NotificationManager.error(
            "Error fetching reports from the API: ",
            error
          );
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    const currentPath = location.pathname;
    let route = "";

    if (currentPath.includes("reports-admin")) {
      route = "ADMIN";
    } else if (currentPath.includes("reports-lab")) {
      route = "LAB";
    } else if (currentPath.includes("reports-others")) {
      route = "Others";
    }

    if (route && route !== appActiveRoute) {
      setAppActiveRoute(route);
      fetchReports(route);
    }

    return () => {
      isMounted = false;
    };
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (adminReportsData && searchTerm) {
      const filteredResults = adminReportsData.filter((report) =>
        Object.values(report).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      setFilteredReports(filteredResults);
    } else {
      setFilteredReports(adminReportsData);
    }
  }, [searchTerm, adminReportsData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleReportClick = (reportId) => {
    // Construct the report URL with username and password included
    const reportUrl = `http://${reportAccount}:${reportPassword}@${reportServer}/ReportServer/Pages/ReportViewer.aspx?%2fVLPRSReports%2f${reportId}&rs:Command=Render`;
    // Open the report URL in a new tab
    window.open(reportUrl, "_blank");
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);
    const sortedReports = stableSort(
      filteredReports,
      getComparator(newOrder, property)
    );
    setFilteredReports(sortedReports);
  };

  return (
    <div>
      <span className="title">{appActiveRoute} Reports </span>
      <hr />
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: "16px", width: "90%" }}
      />
      <TableContainer
        component={Paper}
        sx={{ maxHeight: 500, overflowY: "auto", width: "99%" }}
      >
        <Table sx={{ minWidth: 700 }} aria-label="admin reports table" stickyHeader>
          <TableHead
            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
          >
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "description"}
                  direction={orderBy === "description" ? order : "asc"}
                  onClick={() => handleRequestSort("description")}
                >
                  Description/Title
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "msrsReport"}
                  direction={orderBy === "msrsReport" ? order : "asc"}
                  onClick={() => handleRequestSort("msrsReport")}
                >
                  Report file name
                </TableSortLabel>
              </TableCell>

              <TableCell>
                <TableSortLabel
                  active={orderBy === "reportType"}
                  direction={orderBy === "reportType" ? order : "asc"}
                  onClick={() => handleRequestSort("reportType")}
                >
                  Report Type
                </TableSortLabel>
              </TableCell>
              <TableCell>Update Order Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredReports &&
              filteredReports
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((report, index) => (
                  <TableRow
                    key={report.msrsReport}
                    sx={{
                      backgroundColor:
                        index % 2 === 0 ? "rgba(0, 0, 0, 0.04)" : "white",
                    }}
                  >
                    <TableCell>{report.description}</TableCell>
                    <TableCell component="th" scope="row">

                      <a href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleReportClick(report.msrsReport);
                        }}
                      >
                        {report.msrsReport}
                      </a>
                    </TableCell>
                    <TableCell>{report.reportType}</TableCell>
                    <TableCell>
                      {report.updateorderstatus ? "Yes" : "No"}
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={filteredReports.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <CommonLoader loading={loading} />
    </div>
  );
};

export default AdminReports;
